module.exports = __webpack_public_path__ + "img/2.7af88c72.jpg";